import _sfc_main from "./OptionPC.vue2.mjs";
/* empty css               */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { ref: "optionRef", class: ["option-container", { active: _setup.isSelected }], on: { "click": _setup.handleChooseOption } }, [_vm.$slots.customOptionContent ? [_vm._t("customOptionContent")] : [_c("span", { staticClass: "option-content", style: _setup.props.customOptionContentStyle }, [_vm._v(_vm._s(_vm.label || _vm.value))])]], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "6aef666e"
);
const OptionPC = __component__.exports;
export {
  OptionPC as default
};
